import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="w-full bg-stone-50 py-20 lg:py-28" data-id="element-154">
      <div className="max-w-4xl mx-auto px-6 lg:px-12" data-id="element-155">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-156">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight" data-id="element-157">
            El problema que nadie nombra (pero todos sienten)
          </h2>

          <div className="space-y-6 text-lg leading-relaxed text-gray-700" data-id="element-158">
            <p data-id="element-159">Si tienes +30 en USA, probablemente tu día se ve así:</p>

            <ul className="space-y-3 ml-6" data-id="element-160">
              <li className="flex items-start" data-id="element-161">
                <span className="text-lime-600 mr-3" data-id="element-162">•</span>
                <span data-id="element-163">trabajo / kids / errands</span>
              </li>
              <li className="flex items-start" data-id="element-164">
                <span className="text-lime-600 mr-3" data-id="element-165">•</span>
                <span data-id="element-166">mensajes, deadlines, tráfico</span>
              </li>
              <li className="flex items-start" data-id="element-167">
                <span className="text-lime-600 mr-3" data-id="element-168">•</span>
                <span data-id="element-169">mil micro-decisiones</span>
              </li>
            </ul>

            <p data-id="element-170">Y luego… la noche.</p>

            <p data-id="element-171">
              La famosa "parte fácil del día" que, en realidad, es cuando ya no
              te queda gasolina.
            </p>

            <p className="text-xl font-semibold text-gray-900" data-id="element-172">
              Ahí aparece: "¿Qué cenamos?"
            </p>

            <p data-id="element-173">A veces ni siquiera es una pregunta. Es un mini-juicio.</p>

            <p data-id="element-174">
              Como si tu cena fuera el reporte final de qué tan bien te fue como
              adulto hoy.
            </p>

            <p className="italic" data-id="element-175">
              Y tú solo quieres algo simple, decente y sin drama.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-16 space-y-8" data-id="element-176">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-177">
            Por qué esto se pone peor con el tiempo
          </h3>

          <div className="space-y-6 text-lg leading-relaxed text-gray-700" data-id="element-178">
            <p data-id="element-179">No es que no sepas cocinar.</p>

            <p data-id="element-180">No es que "te falte disciplina".</p>

            <p data-id="element-181">
              Es que estás viviendo con un enemigo silencioso:{' '}
              <strong className="text-gray-900" data-id="element-182">decision fatigue</strong>.
            </p>

            <p data-id="element-183">
              Cuando tu cerebro ya gastó sus buenas decisiones, te empuja a:
            </p>

            <ul className="space-y-3 ml-6" data-id="element-184">
              <li className="flex items-start" data-id="element-185">
                <span className="text-lime-600 mr-3" data-id="element-186">•</span>
                <span data-id="element-187">improvisar con lo que haya</span>
              </li>
              <li className="flex items-start" data-id="element-188">
                <span className="text-lime-600 mr-3" data-id="element-189">•</span>
                <span data-id="element-190">discutir con quien vive contigo</span>
              </li>
              <li className="flex items-start" data-id="element-191">
                <span className="text-lime-600 mr-3" data-id="element-192">•</span>
                <span data-id="element-193">comprar de más "por si acaso"</span>
              </li>
              <li className="flex items-start" data-id="element-194">
                <span className="text-lime-600 mr-3" data-id="element-195">•</span>
                <span data-id="element-196">pedir takeout "solo hoy"</span>
              </li>
            </ul>

            <p data-id="element-197">… y repetirlo mañana.</p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-16 space-y-8" data-id="element-198">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-199">
            Lo que te vendieron… y por qué no te sirvió
          </h3>

          <div className="space-y-6 text-lg leading-relaxed text-gray-700" data-id="element-200">
            <div className="space-y-4" data-id="element-201">
              <div className="flex items-start" data-id="element-202">
                <span className="text-lime-600 font-bold mr-3" data-id="element-203">✗</span>
                <div data-id="element-204">
                  <strong className="text-gray-900" data-id="element-205">Recetas guardadas:</strong>{' '}
                  te dejan con 200 opciones. Es más trabajo, no menos.
                </div>
              </div>

              <div className="flex items-start" data-id="element-206">
                <span className="text-lime-600 font-bold mr-3" data-id="element-207">✗</span>
                <div data-id="element-208">
                  <strong className="text-gray-900" data-id="element-209">Apps:</strong> te piden que
                  decidas igual (solo que en una pantalla).
                </div>
              </div>

              <div className="flex items-start" data-id="element-210">
                <span className="text-lime-600 font-bold mr-3" data-id="element-211">✗</span>
                <div data-id="element-212">
                  <strong className="text-gray-900" data-id="element-213">Meal prep perfecto:</strong>{' '}
                  funciona el domingo… y muere el miércoles.
                </div>
              </div>

              <div className="flex items-start" data-id="element-214">
                <span className="text-lime-600 font-bold mr-3" data-id="element-215">✗</span>
                <div data-id="element-216">
                  <strong className="text-gray-900" data-id="element-217">Meal kits:</strong> te
                  resuelven, sí… pero a precio de "subscription + cansancio".
                </div>
              </div>
            </div>

            <p className="text-xl font-semibold text-gray-900 pt-4" data-id="element-218">
              No necesitas más ideas.
              <br data-id="element-219" />
              Necesitas menos decisiones.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}